<template>
  <div class="payHome">
    <a-layout>
      <div class="payDiv">
        <div class="page-listHeader">
          <img class="imageLogin" src="./image/logo.jpg" />
        </div>
        <div class="formTable" v-html="apply">
          {{ apply }}
        </div>
        <pay-yesAndNo ref="payYesAndNo"></pay-yesAndNo>
      </div>
    </a-layout>
  </div>
</template>
<script>
import payYesAndNo from '../../components/payYesAndNo/index';
export default {
  data() {
    return {
      collapsed: false,
      defaultSelectedKeys: [],
      defaultOpenKeys: [],
      urlName: [],
      form: this.$form.createForm(this),
      data: '',
      mb: '',
      outTradeNo: '',
      apply: '',
    };
  },
  components: {
    'pay-yesAndNo': payYesAndNo,
  },
  watch: {
    $route() {},
  },
  created() {
    // 获取页面路径信息
    const url = window.location.href;
    const theRequest = new Object();
    // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
    if (url.indexOf('?') != -1) {
      //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
      const str = url.substr(url.indexOf('?') + 1);
      const strs = str.split('&');
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
      }
      // return theRequest;
    }
    console.log('theRequesttheRequest====', theRequest);
    this.apply = theRequest.html;
  },
  mounted() {
    let form = this.$route.query.htmls;
    console.log('form====', form);
    this.apply = form;
    this.$nextTick(() => {
      document.forms[0].submit();
    });
  },
};
</script>

<style lang="less">
.payHome {
  background-color: #ffffff;
  height: 100%;
  .page-spa {
    background-color: rgba(39, 86, 138, 1);
  }
  .ant-breadcrumb {
    display: inline;
  }
  .payDiv {
    position: relative;
    .page-listHeader {
      height: 280px;
      background-image: url(../../components/weChatPayment/image/header.jpg);
      .imageLogin {
        top: 20px;
        width: 300px;
        margin-top: 60px;
      }
    }
    .formTable {
      position: absolute;
      background-color: #ffffff;
      top: 70%;
      left: 10%;
      width: 80%;
      height: 600px;
      border: 1px solid #d2d1d1;
      /*box-shadow: 0 0 4px 2px #d2d1d1;*/
      box-shadow: 0 2px 12px 0 #e1e2e2;
      border-radius: 10px;
      .urlImage {
        width: 400px;
        padding-bottom: 80px;
      }
      .fomrLeft {
        display: inline-block;
        width: 24%;
        margin-right: 100px;
        .product-image {
          width: 220px;
        }
        .pOne {
          width: 90px;
          padding-top: 40px;
          font-size: 20px;
          font-weight: 500;
          top: 41px;
          margin-right: 220px;
        }
        .pTow {
          font-size: 15px;
          font-weight: 500;
        }
        .pThree {
          font-size: 15px;
          font-weight: 500;
        }
      }
      .formRight {
        display: inline-block;
        bottom: 20px;
        width: 360px;
      }
    }
  }
  overflow: hidden;
  .logo {
    width: 200px;
    height: 60px;
    background-color: rgba(255, 255, 255, 0.2);
    margin: 5px 0 5px 0;
    float: left;
    background-size: 200px 60px;
    background-repeat: no-repeat;
  }
}
</style>
